
import {
    ReactElement,
    HTMLAttributes
} from "react";
interface Props extends HTMLAttributes<HTMLElement> {
    placeholder: string;
    value: string;
    myStyle?: string;
    onChange?: any;
    lable?: string;
    error?: string;
    name?:string;

}

export function Textarea({ placeholder, name, value, myStyle, onChange, lable , error }: Props): ReactElement {

    return (
        <div className={`${myStyle && myStyle} custom-textarea`} >
            {lable &&
                <label className="custom-textarea-lable">
                    {lable}
                </label>
            }
            <textarea
                className="textarea"
                placeholder={placeholder}
                defaultValue={value}
                onChange={onChange}
                name={name}
            />
            {error &&
                    <label className="custom-textarea-error">
                        {error}
                    </label>
                }
        </div>
    );
}

export default Textarea;